/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreStandardTaskResponseDto } from '../../models/core-standard-task-response-dto';
import { CoreStandardTaskUpdateDto } from '../../models/core-standard-task-update-dto';

export interface StandardTasksControllerUpdate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the standard task to update.
 */
  id: string;
      body: CoreStandardTaskUpdateDto
}

export function standardTasksControllerUpdate(http: HttpClient, rootUrl: string, params: StandardTasksControllerUpdate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreStandardTaskResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, standardTasksControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreStandardTaskResponseDto>;
    })
  );
}

standardTasksControllerUpdate.PATH = '/o2-core/standard-tasks/{tenant}/{id}';
